import { render, staticRenderFns } from "./CusPaymentsTableMobile.vue?vue&type=template&id=282f4408&scoped=true"
import script from "./CusPaymentsTableMobile.vue?vue&type=script&lang=js"
export * from "./CusPaymentsTableMobile.vue?vue&type=script&lang=js"
import style0 from "./CusPaymentsTableMobile.vue?vue&type=style&index=0&id=282f4408&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282f4408",
  null
  
)

export default component.exports